import { combineReducers } from "redux";
import crawler from "./crawler.js";
import urls from "./urls.js";

export default combineReducers({ crawler, urls });
